import React, { useState } from 'react';

import { useForm } from "react-hook-form";
import ModalContentWrapper from "../ModalContentWrapper";

import DatePickerControl from "root/ReactHookForm/ControlWrappers/DatePickerControl";
import { SmartErrorDiv } from "root/ReactHookForm/FormComponents/SmartErrorDiv";
import { generateSurveys } from "root/DataFunctions/SystemDataFns";
import { parseFormDate } from "root/ReactHookForm/hookFormValidation";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

const ModalGenerateSurveys = ( { onSaveCompleted, onClose, year_to_generate, title } ) =>
{
    const [ isGenerating, setIsGenerating ] = useState ( false ) ;

    const { register, control, handleSubmit, setFocus, setValue, watch, formState: { errors: formErrors } } = useForm (
        {
            defaultValues: {
                params:
                    {
                        deadline: null,
                    }
            }
        } );

    const primaryButtonStyle = {
        marginRight: '0px',
        marginLeft: '10px'
    };

    const onCancel = () =>
    {
        onClose( 'cancel' );
    }

    const onSubmit = (formData) =>
    {
        const deadline = parseFormDate (formData.params.deadline , 'dd/MM/yyyy' )

        const data = { year_to_generate: year_to_generate, deadline: deadline } ;

        setIsGenerating( true ) ;

        generateSurveys(data, (response) =>
        {
            setIsGenerating( false ) ;
            onSaveCompleted( 'saved' );
        })

    }

    const validateEndDate = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Date.";
        }
    }

    const formDisplay = isGenerating ? { display: 'none'} : { display: 'block'} ;
    const spinnerDisplay = isGenerating ? { display: 'block'} : { display: 'none'} ;

    const msgStyle = { textAlign: 'center', fontSize: 'large', color: 'red', marginBottom: '10px' } ;
    const formContent = () =>
    {
        return (
            <div className='buy-card'>
                <h2>{ title }</h2>
                <form style={formDisplay} className='email-all-form' onSubmit={ handleSubmit ( onSubmit ) }>
                    <p style={{textAlign: 'center'}}>You are about to generate a set of survey requests for {year_to_generate}</p>
                    <p style={{textAlign: 'center'}}>This will close all outstanding surveys for the previous year and send out email notifications to Primary DSLs for all providers informing them that a survey is due for completion</p>
                    <p style={{textAlign: 'center'}}>Responses made for the last year will be copied into the new surveys</p>
                    <label>Deadline for audit submission</label>
                    <DatePickerControl name='params.deadline' control={control}
                                       validate={validateEndDate}
                                       placeHolder='Please Select a Deadline Date' readOnly={false}
                                       showTimeInput={false}/>
                    <SmartErrorDiv sectionName='params'  name={'deadline'} formErrors={formErrors} />

                    <div className='modal-button-row'>
                        <button onClick={ () => onCancel () } type="button"
                                className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"/></button>
                        <button type="submit" style={ primaryButtonStyle }
                                className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Generate Surveys<i className="et-check"/></button>
                    </div>
                </form>
                <div style={spinnerDisplay}>
                    <div style={msgStyle}>Generating survey requests - please wait</div>
                    <div style={msgStyle}>Do not refresh your browser!</div>
                    <SpinnerDiv />
                </div>
            </div>
        );

    }


    return (
        <ModalContentWrapper className='modal-one-column'>
            { formContent () }
        </ModalContentWrapper>
    );
}

export default ModalGenerateSurveys;